export default { sha: '2ff8e306956e7339cbc774fc4cc09f90a8ea3834', buildNumber: 'undefined' }
